import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import Checkbox from '@/components/@IntranetLibrary/Checkbox';
import { WORK_SPEC_CHECKLIST_OPTIONS } from '@/utils/approval/workSpecification';
import {
  FieldBlock,
  FieldHeader,
  RestrictCheckLabel,
  RestrictCheckText,
} from './styles';
import type { ApprovalFormValues } from './types';
import { InfoSectionTitle } from '@/components/Approval/@components/InfoSection';

/** 작업사양서(183) 「담당자별 체크 필요 항목 선택」 */
const WorkSpecificationField = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<ApprovalFormValues>();

  return (
    <FieldBlock>
      <FieldHeader>
        <InfoSectionTitle>{t('담당자별 체크 필요 항목 선택')}</InfoSectionTitle>
      </FieldHeader>
      <Controller
        name="workSpecChecklist"
        control={control}
        render={({ field }) => (
          <Box display="flex" flexDirection="column">
            {WORK_SPEC_CHECKLIST_OPTIONS.map((key) => (
              <RestrictCheckLabel
                key={key}
                control={
                  <Checkbox
                    size="small"
                    checked={field.value.includes(key)}
                    onChange={(e) =>
                      field.onChange(
                        WORK_SPEC_CHECKLIST_OPTIONS.filter((k) =>
                          k === key
                            ? e.target.checked
                            : field.value.includes(k),
                        ),
                      )
                    }
                  />
                }
                label={
                  <RestrictCheckText variant="body2">
                    {t(key)}
                  </RestrictCheckText>
                }
              />
            ))}
          </Box>
        )}
      />
    </FieldBlock>
  );
};

export default WorkSpecificationField;
